module.exports = __webpack_public_path__ + "img/chart_empty.2e3137af.png";